export const formatHtml = (html: string): string => {
    let formatted = '';
    let indent = '';
    const tab = '  '; // 2 spaces indentation

    html.split(/>\s*</).forEach(function (element) {
        if (element.match(/^\/\w/)) {
            indent = indent.substring(tab.length);
        }

        // Handle JSON-LD scripts specifically
        if (element.startsWith('script') && element.includes('application/ld+json')) {
            const match = element.match(/^(script[^>]*>)(.*)(<\/script)$/s);
            if (match) {
                const [_, openTag, content, closeTag] = match;
                try {
                    const json = JSON.parse(content);
                    const formattedJson = JSON.stringify(json, null, 2);
                    // Add indentation to each line of JSON
                    const indentedJson = formattedJson.split('\n').map(line => indent + tab + line).join('\n');

                    // Construct the formatted element. Note: The loop adds '<' at start and '>' at end.
                    // element currently is: script...>...content...</script
                    // We want: script...>\n...formatted...\n...script

                    // We need to be careful because the loop wraps 'element' with < and >.
                    // So we return the content *inside* the outer < and >.
                    // openTag includes the closing > of the opening tag. e.g. script type="...">
                    // closeTag includes the opening < of the closing tag. e.g. </script

                    // Actually, let's look at how 'element' is formed.
                    // If HTML is <script>...</script>, split removes ><.
                    // element is script>...</script

                    // So openTag in my regex (script[^>]*>) matches script...>
                    // closeTag (<\/script) matches </script

                    // So if we reconstruct:
                    // openTag + '\n' + indentedJson + '\n' + indent + closeTag

                    // The loop adds < at start -> <script...>
                    // The loop adds > at end -> </script>

                    // This seems correct.

                    element = openTag + '\n' + indentedJson + '\n' + indent + closeTag;
                } catch (e) {
                    // JSON-LD parsing failed, keep original content
                }
            }
        }

        formatted += indent + '<' + element + '>\r\n';

        if (element.match(/^<?\w[^>]*[^\/]$/) && !element.startsWith("input") && !element.startsWith("img") && !element.startsWith("br") && !element.startsWith("hr") && !element.startsWith("meta") && !element.startsWith("link") && !element.startsWith("script")) {
            indent += tab;
        }
    });

    return formatted.substring(1, formatted.length - 3);
};
